$(function () {
    $('[data-toggle="popover"]').popover();
});

$(document).on('click', function (e) {
    $('[data-toggle="popover"],[data-original-title]').each(function () {
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false  // fix for BS 3.3.6
        }
    });
});

// [foreign, domestic]
var travel_insurance_persons_0_12_val = [0, 0];
var travel_insurance_persons_13_65_val = [1, 1];
var travel_insurance_persons_66_70_val = [0, 0];
var travel_insurance_persons_71_75_val = [0, 0];
var travel_insurance_persons_76_80_val = [0, 0];
var travel_insurance_persons_81_85_val = [0, 0];
$("[data-toggle=popover]").on('shown.bs.popover', function () {
    var type = $(this).data('type');
    var typeIndex = 0;
    var parent = '#foreignTravelInsurance';
    if (type === 'domestic') {
        parent = '#domesticTravelInsurance';
        typeIndex = 1;
    }
    var $travel_insurance_persons_0_12 = $('body').find(parent + " input[name='travel_insurance_persons_0_12']");
    var $travel_insurance_persons_13_65 = $('body').find(parent + " input[name='travel_insurance_persons_13_65']");
    var $travel_insurance_persons_66_70 = $('body').find(parent + " input[name='travel_insurance_persons_66_70']");
    var $travel_insurance_persons_71_75 = $('body').find(parent + " input[name='travel_insurance_persons_71_75']");
    var $travel_insurance_persons_76_80 = $('body').find(parent + " input[name='travel_insurance_persons_76_80']");
    var $travel_insurance_persons_81_85 = $('body').find(parent + " input[name='travel_insurance_persons_81_85']");

    // Popover content is usually appended to body; fall back to visible popover inputs
    if (!$travel_insurance_persons_0_12.length) {
        $travel_insurance_persons_0_12 = $('.popover.in, .popover.show').find("input[name='travel_insurance_persons_0_12']");
        $travel_insurance_persons_13_65 = $('.popover.in, .popover.show').find("input[name='travel_insurance_persons_13_65']");
        $travel_insurance_persons_66_70 = $('.popover.in, .popover.show').find("input[name='travel_insurance_persons_66_70']");
        $travel_insurance_persons_71_75 = $('.popover.in, .popover.show').find("input[name='travel_insurance_persons_71_75']");
        $travel_insurance_persons_76_80 = $('.popover.in, .popover.show').find("input[name='travel_insurance_persons_76_80']");
        $travel_insurance_persons_81_85 = $('.popover.in, .popover.show').find("input[name='travel_insurance_persons_81_85']");
    }

    $travel_insurance_persons_0_12.TouchSpin({
        min: 0,
        step: 1,
        initval: travel_insurance_persons_0_12_val[typeIndex],
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $travel_insurance_persons_0_12.on('change', function () {
        travel_insurance_persons_0_12_val[typeIndex] = $(this).val();
        change_travel_insurance_persons_number(parent, typeIndex);
    });
    $travel_insurance_persons_13_65.TouchSpin({
        min: 0,
        step: 1,
        initval: travel_insurance_persons_13_65_val[typeIndex],
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $travel_insurance_persons_13_65.on('change', function () {
        travel_insurance_persons_13_65_val[typeIndex] = $(this).val();
        change_travel_insurance_persons_number(parent, typeIndex);
    });
    $travel_insurance_persons_66_70.TouchSpin({
        min: 0,
        step: 1,
        initval: travel_insurance_persons_66_70_val[typeIndex],
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $travel_insurance_persons_66_70.on('change', function () {
        travel_insurance_persons_66_70_val[typeIndex] = $(this).val();
        change_travel_insurance_persons_number(parent, typeIndex);
    });
    $travel_insurance_persons_71_75.TouchSpin({
        min: 0,
        step: 1,
        initval: travel_insurance_persons_71_75_val[typeIndex],
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $travel_insurance_persons_71_75.on('change', function () {
        travel_insurance_persons_71_75_val[typeIndex] = $(this).val();
        change_travel_insurance_persons_number(parent, typeIndex);
    });
    $travel_insurance_persons_76_80.TouchSpin({
        min: 0,
        step: 1,
        initval: travel_insurance_persons_76_80_val[typeIndex],
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $travel_insurance_persons_76_80.on('change', function () {
        travel_insurance_persons_76_80_val[typeIndex] = $(this).val();
        change_travel_insurance_persons_number(parent, typeIndex);
    });
    $travel_insurance_persons_81_85.TouchSpin({
        min: 0,
        step: 1,
        initval: travel_insurance_persons_81_85_val[typeIndex],
        buttondown_class: "btn btn-info",
        buttonup_class: "btn btn-info"
    });
    $travel_insurance_persons_81_85.on('change', function () {
        travel_insurance_persons_81_85_val[typeIndex] = $(this).val();
        change_travel_insurance_persons_number(parent, typeIndex);
    });
});
function change_travel_insurance_persons_number(parent, typeIndex) {
    var val = parseInt(travel_insurance_persons_0_12_val[typeIndex]) + parseInt(travel_insurance_persons_13_65_val[typeIndex]) + parseInt(travel_insurance_persons_66_70_val[typeIndex]) + parseInt(travel_insurance_persons_71_75_val[typeIndex]) + parseInt(travel_insurance_persons_76_80_val[typeIndex]) + parseInt(travel_insurance_persons_81_85_val[typeIndex]);
    $('body').find(parent + ' input[name="travel_insurance_persons"]').val(val + ' مسافر');
}

var travelInsuranceSearch = function (parent, destination, Duration) {
    function showFieldError($field, message) {
        var $target = $field;
        if ($field && $field.length) {
            if ($field.hasClass('select2-hidden-accessible')) {
                $target = $field.next('.select2');
            } else if ($field.next('.select2').length) {
                $target = $field.next('.select2');
            } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                $target = $field.next();
            }
            try {
                $target.animateCss('shake');
            } catch (e) {}
            $target.addClass('travel-field-error');
            setTimeout(function () {
                $target.removeClass('travel-field-error');
            }, 2500);
        }
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                icon: 'warning',
                title: 'توجه',
                text: message,
                confirmButtonText: 'باشه',
                confirmButtonColor: '#ED6D37'
            });
        } else {
            alert(message);
        }
        return false;
    }

    var typeIndex = 0;
    if(parent == '#domesticTravelInsurance') {
        typeIndex = 1;
    }

    if (destination.val() == -1 || destination.val() == '' || destination.find("option:selected").text() == "") {
        return showFieldError(destination, 'لطفاً مقصد سفر را انتخاب کنید.');
    }

    if (Duration.val() == -1 || Duration.find("option:selected").text() == "") {
        return showFieldError(Duration, 'لطفاً مدت سفر را انتخاب کنید.');
    }

    if (
        parseInt(travel_insurance_persons_0_12_val[typeIndex]) == 0 &&
        parseInt(travel_insurance_persons_13_65_val[typeIndex]) == 0 &&
        parseInt(travel_insurance_persons_66_70_val[typeIndex]) == 0 &&
        parseInt(travel_insurance_persons_71_75_val[typeIndex]) == 0 &&
        parseInt(travel_insurance_persons_76_80_val[typeIndex]) == 0 &&
        parseInt(travel_insurance_persons_81_85_val[typeIndex]) == 0
    ) {
        return showFieldError($(parent + ' input[name="travel_insurance_persons"]'), 'لطفاً تعداد مسافر و بازه سنی را مشخص کنید.');
    }

    var url_param = '';
    var destination_id = destination.val();
    var destination_name = destination.find("option:selected").data('value');
    var duration = Duration.val().split('-');
    var duration_start = duration[0];
    var duration_end = duration[1];

    if ((destination_id && destination_id != -1)) {
        url_param += '?destination_id=' + destination_id;
    }

    if (duration && duration != '') {
        if (destination_id && destination_id != -1) {
            url_param += '&';
        }
        url_param += 'minDuration=' + duration_start + '&maxDuration=' + duration_end;
    }
    if (true) {
        if (destination_id && destination_id != -1) {
            url_param += '&';
        }
        range_string = 'ageRange=';
        range_string += '0_12-' + parseInt(travel_insurance_persons_0_12_val[typeIndex]) + ',';
        range_string += '13_65-' + parseInt(travel_insurance_persons_13_65_val[typeIndex]) + ',';
        range_string += '66_70-' + parseInt(travel_insurance_persons_66_70_val[typeIndex]) + ',';
        range_string += '71_75-' + parseInt(travel_insurance_persons_71_75_val[typeIndex]) + ',';
        range_string += '76_80-' + parseInt(travel_insurance_persons_76_80_val[typeIndex]) + ',';
        range_string += '81_85-' + parseInt(travel_insurance_persons_81_85_val[typeIndex]);
        url_param += range_string;
    }
    window.location = travelInsuranceSearchUrl + '/' + destination_name + url_param;
};

$(document).ready(function () {
    // Fallback tab switcher (BS3 data-toggle + BS5 data-bs-toggle)
    $('#travel-insurance-tab').on('click', '.tab-container > ul.tabs > li > a[href^="#"]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var target = $link.attr('href');
        var $container = $link.closest('.tab-container');

        $container.children('ul.tabs').children('li').removeClass('active');
        $link.parent('li').addClass('active');

        $container.children('.tab-content').children('.tab-pane')
            .removeClass('active in show');
        $container.children('.tab-content').children(target)
            .addClass('active in show');
    });

    $('.travel_insurance_searchBtn_top').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var type = $(this).data('type');
        var parent = '#foreignTravelInsurance';
        if (type === 'domestic') {
            parent = '#domesticTravelInsurance';
        }
        var destination_id = $(parent + ' .travel_destination_select, ' + parent + ' select[name="destination_id"]').first();
        var duration = $(parent + ' .travel_duration_select, ' + parent + ' select[name="duration"]').first();

        travelInsuranceSearch(parent, destination_id, duration);
        return false;
    });
});

$.fn.extend(
    {
        animateCss: function (animationName) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated ' + animationName).one(
                animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                }
            );
        }
    }
);
